import axiosInstance from "./axios";

export const loginRequest = async (username, password, remember_me) => {
    const { data } = await axiosInstance.post("api/admin/login", { username, password, remember_me });
    return data;
};

export const checkAuthStatus = async () => {
    const { data } = await axiosInstance.get("api/admin/get-all-admin");
    return data.data[0];
};

export const logoutRequest = async () => {
    const { data } = await axiosInstance.post("api/admin/logout");
    return data;
};